import React, { useMemo } from "react";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import Participant from "./Participant";
import { User } from "models/User";
import { useSelector } from "react-redux";
import { RootState } from "store";
import Trainer from "./Trainer";
import ParticipantNew from "./ParticipantNew";
import { useContext, useEffect, useRef, useState } from 'react'
import useMediaQuery from "hooks/useMediaQuery";
import ParticipantExpanded from "./ParticipantExpanded";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import SocketContext from 'socket-context';
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import { Dialog } from '@radix-ui/themes';

interface Props {
    tableDetails: any;
    roomClient?: RoomClient | null;
    minutesx?: any;
    session_id?: any;
}


const OpenClassInteraction = ({ tableDetails, roomClient, minutesx, session_id }: Props) => {
    const consumers: any = useSelector(
        (state: RootState) => state.live.settings.consumers
    );
    const isMobileOrTablet = useMediaQuery("(max-width: 1024px)");
    const [myStream, setMyStream] = useState<any>({});
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [otherStream, setOtherStream] = useState<any>({})
    const [allStream, setAllStream] = useState<any>({})
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    const [isTwoMinutesLeft, setIsTwoMinutesLeft] = useState(false);
    const profileData = useSelector((state: any) => state?.auth?.user as User);
    const producers = useSelector(
        (state: RootState) => state.live.settings.producers
    );
    const [timeExtended, setTimeExtended] = useState(false);

    const [alertMessage, setAlertMessage] = useState('');
    const [timer, SetTimer] = useState<any>();

    const socketList = useContext(SocketContext);
    let userInfoHandler = useRef<UserInfoMapperSocketHandler>()

    useEffect(() => {
        if (Number(minutesx) > 0) {
            setMinutes(minutesx);
        }
    }, [minutesx]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                if (minutes === 2 && seconds === 0) {
                    console.log('vvvvvvvvv');
                    setAlertMessage('Open Class Interaction ends in 2mins!');
                    setIsTwoMinutesLeft(true);
                }
                if (minutes === 0 && seconds === 0) {
                    clearInterval(timer);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [minutes, seconds]);

    useEffect(() => {
        if (isTwoMinutesLeft === true) {
            setTimeout(() => {
                setIsTwoMinutesLeft(false);
            }, 6000);
        }
    }, [isTwoMinutesLeft]);

    useEffect(() => {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }, []);

    const handleOnMessage = async (_data) => {
        console.log('role play data::', JSON.stringify(_data));
        const data = JSON.parse(_data);
        if (data.type === 'live_session') {
            if (data?.sub_type === 'time_extend') {
                setTimeExtended(true);
                SetTimer(data);
            }
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setTimeExtended(false);
        }, 5000);
    }, [timeExtended]);

    const getAspectRatio = (count: number): string => {
        if (count === 1) return "16 / 9";  // widescreen
        if (count === 2) return "4 / 3";
        if (count === 3) return "4 / 3";   // classic
        return "3 / 2";                    // fallback (≈1.5)
    };

    const totalParticipants = tableDetails.length;

    const aspectRatio = getAspectRatio(totalParticipants);
    const columns = isMobileOrTablet ? Math.min(totalParticipants, 2) : Math.min(totalParticipants, 3);
    const rows = Math.ceil(totalParticipants / columns);

    const gridStyle = {
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
    };
    useEffect(() => {
        roomClient?.consumerResumeAllAudio();
    }, []);

    useEffect(() => {
        const mergedStreams = { ...otherStream, ...myStream };
        setAllStream(mergedStreams);

    }, [myStream, otherStream]);

    useEffect(() => {
        const producersArray = Object.values(producers);

        const videoProducer: any = producersArray?.find(
            (producer: any) => producer.kind === 'video'
        );
        if (videoProducer) {
            const stream = new MediaStream();
            stream.addTrack(videoProducer.track);
            setMyStream({ [profileData?.email]: stream })
        } else {
            setMyStream({ [profileData?.email]: { toURL: () => { } } })
        }
    }, [producers]);
    const groupBy = (objectArray: any[], property: string) => {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    useEffect(() => {
        if (consumers) {
            let _consumers = Object?.values(consumers);
            let newConsumerArray = groupBy(_consumers, "peerId");
            let _newConsumerArray = Object.values(newConsumerArray);
            let origianlStreamArray: any;
            _newConsumerArray &&
                _newConsumerArray?.map((c: any, i: number) => {
                    let stream = new MediaStream();
                    let peerId: any;
                    c?.map((c1: any, i1: number) => {
                        stream?.addTrack(c1?.track);
                        peerId = c1?.peerId;
                    });
                    origianlStreamArray = { ...origianlStreamArray, [peerId]: stream };
                });
            setOtherStream(origianlStreamArray);
            return
        }
    }, [consumers]);
    const getTrack = (email: string) => {
        if (!consumers || !producers || !profileData) {
            console.warn("No consumers, producers, or profileData available");
            return { audio: null, video: null };
        }

        if (email === profileData.email) {
            const validProducers = Object.values(producers).filter(
                (producer: any) => producer !== undefined
            );

            const videoProducer: any = validProducers.find(
                (producer: any) => producer?.kind === "video"
            );
            const audioProducer: any = validProducers.find(
                (producer: any) => producer?.kind === "audio"
            );

            return {
                audio: audioProducer
                    ? { track: audioProducer.track, locallyPaused: audioProducer.paused }
                    : null,
                video: videoProducer
                    ? { track: videoProducer.track, locallyPaused: videoProducer.paused }
                    : null,
            };
        }

        let audioConsumer = null;
        let videoConsumer = null;

        for (const id in consumers) {
            if (consumers[id].peerId === email && consumers[id].track) {
                if (consumers[id].kind === "audio") {
                    audioConsumer = consumers[id];
                } else if (
                    consumers[id].kind === "video" &&
                    !consumers[id].appData?.share
                ) {
                    videoConsumer = consumers[id];
                }
            }
        }

        return { audio: audioConsumer, video: videoConsumer };
    };

    useEffect(() => {
        if (alertMessage) {
            const timeout = setTimeout(() => {
                setAlertMessage("");
            }, 5000); // auto hide in 5 secs

            return () => clearTimeout(timeout);
        }
    }, [alertMessage]);


    const formatTime = (time) => {
        return time < 10 ? `0${time}` : `${time}`;
    };
    return (
        <div className="mobile:mx-0 mx-2">
            <div
                className="my-[2%] bg-[rgba(91,93,107,1)] flex flex-row justify-center items-center  px-[4%] py-[0.7%] rounded-[0.5%]"
            >
                <span
                    className="text-white text-sm font-normal"
                    style={{ fontFamily: "'Lato', sans-serif" }}
                >
                    Remaining :
                </span>
                <span
                    className="text-white text-sm font-semibold pr-[2%]"
                    style={{ fontFamily: "'Lato', sans-serif" }}
                >
                    {`${formatTime(minutes)}m:${formatTime(seconds)}s`}
                </span>
            </div>
            {/* <div className="text-2xl text-white mobile:justify-center flex justify-start m-2 ">
                <div className="bg-gray-600 p-2 rounded-lg opacity-50">
                    <AiOutlineFullscreenExit onClick={view} />
                </div>
            </div> */}
            {/* <div className="flex flex-col w-full justify-center mt-2 mobile:mt-6">
                <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
            </div> */}
            <>
                <div className="grid text-white mobile:gap-2  m-2 gap-2" style={gridStyle}>
                    {tableDetails.map((seat: any, index: any) => (
                        allStream[seat.email || seat.participant_email] && (
                            <ParticipantExpanded
                                key={seat.id || seat.participant_id}
                                name={seat.participant_name || seat.name}
                                id={seat.participant_id || seat.id}
                                profilePhoto={seat.profilePhoto}
                                size="9"
                                radius="small"
                                streamArray={getTrack(seat.participant_email || seat.email)}
                                aspectRatio={aspectRatio}
                                video="yes"
                                audio="yes"
                                style={aspectRatio === "16 / 9" ? isMobileOrTablet ? {} : { maxHeight: "70%" } : {}}
                            />
                        )
                    ))}

                </div>
            </>

            {/* <div className="flex justify-center">
        {activeAnotherSeat && (
          <button className="bg-orange-600 border-2 border-white rounded-3xl text-white px-2 py-1">
            Leave Group
          </button>
        )}
      </div> */}
            {timeExtended && (
                <div className="fixed inset-0 flex justify-center items-end mb-[10%] bg-[rgba(33,32,37,0.6)]">
                    <div className="px-[5%] py-[3.5%] w-[70%] flex flex-row justify-center items-center rounded-[2%] bg-white">
                        <span
                            className="text-black text-sm font-bold text-center"
                            style={{ fontFamily: "'Lato', sans-serif" }}
                        >
                            Trainer has extended the Open Class Interaction duration by {timer?.extend_time} Minutes extended
                        </span>
                    </div>
                </div>
            )}

            {alertMessage && (
                <div className="fixed inset-0 flex justify-center items-end mb-[10%] bg-[rgba(33,32,37,0.6)]">
                    <div className="px-[1%] py-[1%] w-[70%] flex flex-row justify-center items-center rounded-[2%] bg-white">
                        <span
                            className="text-black text-sm font-bold text-center"
                            style={{ fontFamily: "'Lato', sans-serif" }}
                        >
                            {alertMessage}
                        </span>
                    </div>
                </div>
            )}

        </div>
    );
};
export default OpenClassInteraction;